import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function Offer() {
  return <section id="offer" className="scroll-mt-12 border-y border-ink-line bg-ink-panel px-4 py-8" data-id="element-96" data-mp="1mn913ker4y64">
      <div className="mx-auto max-w-2xl text-center" data-id="element-97" data-mp="1hopdlfkifebn">
        <h2 className="text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-98" data-mp="1hp7kd64staxt">
          Special Offer — Complete 6-in-1 System
        </h2>
        <p className="mt-2 text-sm leading-snug text-ink-text sm:text-base" data-id="element-99" data-mp="p00bpebmr4yu">
          Get instant access today and completely transform the way you prepare, organize, and
          deliver your speech therapy sessions.
        </p>

        <div className="mt-4 rounded-2xl border border-gold/60 bg-ink-bg p-5" data-id="element-100" data-mp="ywwm5pl3a161">
          <a href={CHECKOUT_URL} className="block" aria-label="Buy Speech Therapy Pro" data-id="element-101" data-mp="2fboey3m5dafv">
            <img src={PRODUCT_IMG} alt="Speech Therapy Pro complete system with bonuses" className="mx-auto mb-3 w-full max-w-[240px] rounded-lg transition-transform duration-200 hover:scale-[1.02]" data-id="element-102" data-mp="2add53svuqzxn" />
          </a>
          <h3 className="text-base font-extrabold sm:text-xl" data-id="element-103" data-mp="uiiq5xjsmxs7">🗣️ Speech Therapy Pro™</h3>
          <p className="text-xs text-ink-text sm:text-sm" data-id="element-104" data-mp="zhvc8g2uc0tq">
            Complete 6-in-1 Operating System + 5 Premium Bonuses
          </p>

          <p className="mt-3 text-sm text-ink-text line-through sm:text-base" data-id="element-105" data-mp="13jgkfo4fjqxl">
            Regular Price: $97
          </p>
          <p className="mt-1 inline-block rounded-md bg-gold px-3 py-1 font-display text-xs font-bold uppercase text-[#0D0D0D] sm:text-sm" data-id="element-106" data-mp="6rmsijsnp8d1">
            🔥 72% OFF — Limited-Time Launch Offer
          </p>
          <p className="mt-2 font-display text-3xl font-extrabold text-gold sm:text-5xl" data-id="element-107" data-mp="fskwj233hfvm">
            Today Only: $27 USD
          </p>
          <p className="mt-1 text-xs text-ink-text sm:text-sm" data-id="element-108" data-mp="3k9fbm6awlcpz">
            Pay securely in your local currency.
          </p>
          <p className="mt-2 text-xs font-semibold text-white sm:text-sm" data-id="element-109" data-mp="3o8wf4u6rrzsi">
            🔥 Last Chance! This special price expires when the countdown reaches zero.
          </p>

          <CTAButton href={CHECKOUT_URL} className="mt-4" data-id="element-110" data-mp="qhfm1o0ziw8e">
            🚀 YES! I WANT MY COMPLETE 6-IN-1 SYSTEM
          </CTAButton>

          <div className="mt-3 flex flex-col items-center gap-1 text-[11px] text-ink-text sm:flex-row sm:justify-center sm:gap-4 sm:text-sm" data-id="element-111" data-mp="154qx7ot98e7z">
            <span className="flex items-center gap-1.5" data-id="element-112" data-mp="cgmo0tbh5j0j">
              <StarIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-113" data-mp="ch4ueirupdm6" />⭐ 4.9/5 —
              Verified Therapist Reviews
            </span>
            <span className="flex items-center gap-1.5" data-id="element-114" data-mp="lht9zhww7m16">
              <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-115" data-mp="lfgl0kspwbem" />
              🛡️ 7-Day Money-Back Guarantee — Zero Risk
            </span>
          </div>
        </div>
      </div>
    </section>;
}